export default {
  us: {
    title: '<strong class=\'aqua\'>This is how all began...</strong>',
    description: 'Grupo Ilú was our first experience as a company, a great time when we set up to the mission of' +
    '<strong class=\'aqua\'> create original applications and websites </strong>' +
    'that met the expectations of emerging entrepreneurs throughout Venezuela.',
    time1: 'Starting a business by our own had been a students dream until 2008, when we founded Grupo Ilu.',
    barraDescription: 'Four years later we got in a new stage, with a renewed team.',
    subtitulo: 'Apök',
    section2: {
      title: 'We became',
      text1: 'We chose a name that would honor the love we feel for Venezuela. ' +
      'We pick Apök because means <i style="font-style: italic"> <strong>fire</strong> in the Pemón language.</i>',
      text2: 'The legend tells that the first humans, Makunaimö and his brother Chikö, obtained fire from taking a lighted ' +
      'branch of Mutuk, the fire bird. <strong style="font-style: italic">The name clicked immediately!</strong>'
    },
    barraOscura: {
      frase: '…and we keep growing',
      text1: 'From three software developers and one designer we were growing up, step by step ' +
      'with so much effort and dedication, helping  entrepreneurs to build their digital projects, as far as to have the good ' +
      'fortune to cross the borders'
    },
    difference: {
      title: '<strong class=\'difference-title w-100 float-left\'>We become <br/>passionate <br/>workers</strong>',
      text: 'We are excited to start every new project. We know the responsibility and respect that we should have with our ' +
      'clients. We are characterized by the productivity, effectiveness and professionalism in each project and... Of course, Our good sense of humor!'
    },
    textHeader: 'OUR HISTORY',
    textFooter: 'We started in 2012 and here we are! Growing up and learning every day.',
    designer: 'Designer'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en/about_us.js